import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCard";
import annexation from "../../Assets/annexation-main.gif";

function Projects() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);
  
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          <strong>Projects</strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col className="project-card">
            <ProjectCard
              imgPath={annexation}
              title="Annexation"
              description="Annexation is a fast-paced real-time strategy game with old-school roots.  Build bases, train armies, and outmaneuver your enemy to claim victory. Start by playing the campaign and then challenge yourself in Arcade Missions which bring the intensity of multiplayer RTS into a single-player setting."
              trailerLink="https://www.youtube.com/watch?v=6yzR4D9MDRU"
              steamLink="https://store.steampowered.com/app/4622430/Annexation/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
